import { Link } from "react-router-dom";
import { NewTabLink } from "./UI/NewTabLink";

export function SummerStatus(props: { SummerStatusDescription: string, SummerStatusFlag: string, SummerApplicationTypeID: 178 | 179 }) {
    // console.log(props);

    const _campus = props.SummerApplicationTypeID === 178 ? "Colchester" : "Southend";

    return <>
        <p><b>My Accommodation Application Status:</b></p>

        <p>{props.SummerStatusDescription + (props.SummerStatusDescription?.endsWith('.') ? '' : '.')}</p>

        <p>&nbsp;</p>

        {props.SummerStatusFlag === "UNKNOWN" && <p>
            We are unable to determine your application status. If you have a question about Accommodation Services, please
            see the Accommodation Services web
            pages. <NewTabLink to="https://www.essex.ac.uk/life/accommodation">https://www.essex.ac.uk/life/accommodation</NewTabLink>
        </p>}

        {props.SummerStatusFlag === "OFFER" && <p><Link to="Summer">View (and accept or reject) your accommodation offer(s).</Link></p>}

        {props.SummerStatusFlag === "ACCEPT" && <p><Link to="Summer">View accepted accommodation offer(s) and/or complete your eInduction to accommodation at Essex.</Link></p>}

        {props.SummerStatusFlag === "INDUCTED" && <p><Link to="Summer">View details of accepted accommodation and review completed e-induction.</Link></p>}

        {props.SummerStatusFlag === "REJECT" && <p><Link to="Summer">Re-apply for Summer Vacation accommodation ({_campus} Campus) online.</Link></p>}

        {props.SummerStatusDescription === 'You do not have an application' && <p><Link to="Summer">Apply for {_campus} Campus accommodation (Summer Vacation only) online.</Link></p>}

        {props.SummerStatusDescription === 'You have started making an application' && <p><Link to="Summer">Complete your Summer Vacation application for {_campus} Campus accommodation online.</Link></p>}
    </>
}

{/*
'REJECT' (1) = ' You have previously rejected, or you have been rejected for, an offer of accommodation. If this was
not your intent, please contact Accommodation Services. [no link]
'REJECT' (2) = ' You have previously rejected, or you have been rejected for, an offer of accommodation'.
Re-apply for Summer Vacation accommodation (Colchester/Southend Campus) online.

'COMPLETE' = 'Your application has been received'
Your application has been received. [no link]
'COMPLETE' = 'Your application has been received and has been processed'
Your application has been received and has been processed. [no link]
*/}